import React from 'react';

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="21" width="21" viewBox="4 4 12 12">
    <path d="M6.688 15.812V4.146L15.854 9.979Z" />
  </svg>
);

export default PlayIcon;
